import { MenuItem, Select, FormControl, InputLabel, useMediaQuery, useTheme } from '@mui/material';
import { useLanguage } from '../contexts/LanguageContext';
import { useTranslation } from '../hooks/useTranslation';

const LanguageSelector = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { language, languages, setLanguage } = useLanguage();
  const { t } = useTranslation();

  return (
    <FormControl size={isMobile ? 'small' : 'medium'} sx={{ minWidth: isMobile ? 100 : 120 }}>
      <InputLabel id="language-selector-label">{t('language.selector.title', 'Language')}</InputLabel>
      <Select
        labelId="language-selector-label"
        value={language}
        label={t('language.selector.title', 'Language')}
        onChange={(e) => setLanguage(e.target.value)}
        sx={{
          '& .MuiSelect-select': {
            paddingRight: '32px !important',
          }
        }}
      >
        {languages.map((lang) => (
          <MenuItem key={lang.code} value={lang.code}>
            {lang.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguageSelector;